import ReportList from './ReportList';
import ReportEdit from './ReportEdit';
import { ReportIcon } from '../../core/themes/icons/ReportIcon';

export default {
  list: ReportList,
  edit: ReportEdit,
  icon: ReportIcon
};
